import styled from 'styled-components';

export const Container = styled.section`
  margin: 20px 0;
`;

export const CopyContainer = styled.section`
  max-width: 600px;
  width: 100%;
  margin: 50px auto 0;
`;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/ESSPoints/styles.js